import { Box } from "@mui/material";

import { mergeSxProps } from "../../lib/mergeSxProps";
import { BaseIconButton } from "../BaseIconButton";
import { CbhIcon } from "../CbhIcon";
import { type IconButtonProps } from "../IconButton";
import { LoadingSpinner } from "../LoadingSpinner";

export interface LoadingIconButtonProps extends IconButtonProps {
  isLoading: boolean;
}

/**
 * An icon button that renders a loading spinner in place of the icon while the button is loading
 * Uses `IconButton` internally, so it supports all the same props
 */
export function LoadingIconButton(props: LoadingIconButtonProps) {
  const { isLoading, sx, invert, disabled, iconType, variant, ...restProps } = props;

  return (
    <BaseIconButton
      {...restProps}
      // This will override role only on loading
      {...(isLoading && { role: "progressbar" })}
      disabled={isLoading || disabled}
      invert={invert}
      variant={variant}
      sx={mergeSxProps(sx, {
        ...(isLoading && {
          "& svg": { color: "transparent !important" },
        }),
      })}
    >
      {!isLoading && <CbhIcon type={iconType} />}

      {isLoading && (
        <Box
          sx={{
            position: "absolute",
            display: "flex",
            visibility: "visible",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <LoadingSpinner size="small" variant={invert ? "invert" : "primary"} />
        </Box>
      )}
    </BaseIconButton>
  );
}
